<template>
  <div :class="['container',showNotice?'':'pointer']">
    <div class="notice" v-if="showNotice">
      <p class="title">
        护眼说明
        <span class="clossBtn cursor" @click.stop="closeNotice"></span>
      </p>
      <div class="content">
        <p style="margin-bottom:20px;">亲爱的同学，眼睛是心灵的窗户，我们在认真学习的同时，也要保护好自己的眼睛，上课时注意以下两点:</p>
        <p>1、每节课中，会有“眼保健操”环节，要记得认真做操喔~</p>
        <p>2、开启“护眼模式”上课会更好的保护眼睛~</p>
      </div>
    </div>
    <div class="contentBox"></div>
    <Toast v-if="showToast" :showText="showText" @toastCallBack="toastCallBack"/>
  </div>
</template>

<script>
import Toast from "../../../components/basic/toast"; //Toast
import common from "common";
import utils from "utils";
if (LIMI_ENV === "electron") {
  var fs = window.require("fs");
}
export default {
  data() {
    return {
      showNotice: true,
      showText: "护眼模式已开启",
      showToast: false
    };
  },
  props: {
    needToast: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    closeNotice() {
      this.showNotice = false;
    },
    toastCallBack() {
      this.showToast = false;
    }
  },
  components: {
    Toast
  },
  created() {
    if (fs) {
      // console.log(utils.getNodeStorge("hasAccess"),!utils.getNodeStorge("hasAccess"))
      this.showNotice=!utils.getNodeStorge("hasAccess")? true:false
    }else{
       this.showNotice=!common.get("hasAccess")? true:false
    }
  },
  mounted() {
    
    fs ? utils.setNodeStorge("hasAccess", true) : common.set("hasAccess", true);
    if (!this.showNotice && this.needToast) this.showToast = true;
  }
};
</script>
<style lang="less" scoped>
.container {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 999999999;

  .contentBox {
    height: 100%;
    width: 100%;
    background: rgba(105, 95, 30, 0.27);
  }
  .notice {
    width: 562px;
    height: 356px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .title {
      background: #0089ce;
      height: 78px;
      line-height: 78px;
      position: relative;
      color: #ffffff;
      font-size: 26px;
      border-radius: 14px 14px 0 0;
      .clossBtn {
        position: absolute;
        right: 20px;
        top: 50%;
        width: 40px;
        height: 40px;
        line-height: 40px;
        transform: translateY(-50%);
        background: url(../../../assets/img/common/close-icon.png) no-repeat
          center center;
        background-size: 20px;
      }
    }
    .content {
      background: #f1f3f4;
      font-family: PingFang_Regular;
      color: #004466;
      font-size: 21px;
      height: 278px;
      text-align: left;
      padding: 30px 50px;
      border-radius: 0 0 14px 14px;
      text-align: justify;
    }
  }
}
.pointer {
  pointer-events: none;
}
</style>




// WEBPACK FOOTER //
// src/components/basic/eyeshield/eyeshield.vue